<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div>
      <mu-row gutter>
        <mu-col width="80" desktop="50" tablet="70">
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-time-picker
                :label="$t('message.labelTime')"
                mode="portrait"
                fullWidth
                v-model="timeModel.time"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
              ></mu-time-picker>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-date-picker
                :label="$t('message.labelDate')"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
                :dateTimeFormat="dateFormat"
                format="DD-MM-YYYY"
                v-model="timeModel.date"
                :maxDate="maxDate"
                fullWidth
              ></mu-date-picker>
            </mu-col>
          </mu-row>
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                :label="$t('message.cardBloodGlucose')"
                type="number"
                step="any"
                v-if="preference === 'mmoll'"
                v-model.number="reading.blood_glucose_mmoll"
                helpText="mmol/L"
                underlineShow
                fullWidth
              ></mu-text-field>
              <mu-text-field
                :label="$t('message.cardBloodGlucose')"
                type="number"
                step="any"
                v-if="preference === 'mgdl'"
                v-model.number="reading.blood_glucose_mgdl"
                helpText="mg/dL"
                underlineShow
                fullWidth
              ></mu-text-field>
            </mu-col>
          </mu-row>
          <mu-select-field
            v-if="tags"
            :hintText="$t('message.selectText')"
            multiple
            v-model="readingTags"
            :label="$t('message.labelTagYourReading')"
            :fullWidth="true"
            :maxHeight="300"
            :scroller="scroller"
          >
            <mu-menu-item
              v-for="(tag, index) in listTags"
              :key="'reading-tag-' + index"
              :value="tag.tag_id"
              :title="$t(localizeTag(tag.tag))"
            />
          </mu-select-field>
        </mu-col>
      </mu-row>
    </div>
    <mu-flat-button
      style="margin-right: 8px;"
      :label="$t('message.discardText')"
      @click.native="closeEditMode(reading)"
    ></mu-flat-button>
    <button type="submit" style="display: none"></button>
    <mu-raised-button
      @click.native="submitForm"
      :disabled="isUpdating"
      :label="isUpdating ? $t('message.updatingText') : $t('message.updateText')"
      type="button"
      secondary
    ></mu-raised-button>
  </form>
</template>
<script>

  import BloodGlucoseApi from '../../../../api/Tracking/BloodGlucose'
  import ScrollerMixin from '../../../../mixins/ScrollerMixin'
  import TrackingEditMixin from '../../../../mixins/TrackingEditMixin'
  import TagLocalizerMixin from '../../../../mixins/Localization/BgTags/TagLocalizerMixin'



  export default {
    mixins: [TrackingEditMixin, ScrollerMixin, TagLocalizerMixin],
    name: 'bg-edit',
    props: {
      preference: {
        type: String,
        default: 'mmoll'
      },
      item: {
        type: Object,
        default: {}
      },
      tags: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        isUpdating: false,
        readingTags: [],
        listTags: [],
        reading: {
          tags: []
        }
      }
    },
    mounted() {
      let self = this;
      self.listTags = JSON.parse(JSON.stringify(self.tags));
      for (let tag of self.reading.tags) {
        self.readingTags.push(tag.tag_id)
      }
      self.$forceUpdate();
    },
    methods: {
      submitForm() {
        let self = this;
        self.isUpdating = true;
        self.reading.tags = [];
        for (let tag of self.readingTags) {
          const tagFound = self.listTags.filter(function (item) {
            return item.tag_id === tag
          })[0];
          self.reading.tags.push(tagFound)
        }
        BloodGlucoseApi.updateBloodGlucoseTracking(self.reading)
          .then(function (response) {
            self.isUpdating = false;
            let offset = new Date();
            self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
            self.$EventBus.$emit('bgReadingUpdated');
            self.$EventBus.$emit('updateGraphData');
            self.$emit('updateReading', self.reading);
            self.$emit('closeEditPanel')
          })
          .catch(function () {
            self.isUpdating = false;
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BloodGlucoseEdit.vue?3015f8f4